var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonDropzone',{attrs:{"mutation":_vm.mutation,"variables":_vm.variables,"maxFilesize":200,"forName":(_vm.type === 'IMAGE') ? 'รูปภาพ' : ' zip '}})}
var staticRenderFns = []

export { render, staticRenderFns }